export const FETCH_INTEGRATION_REQUESTED = "FETCH_INTEGRATION_REQUESTED"

export const FETCH_INTEGRATION_SUCCESS = "FETCH_INTEGRATION_SUCCESS"

export const FETCH_INTEGRATION_FAILURE = "FETCH_INTEGRATION_FAILURE"

export const CREATE_INTEGRATION_REQUESTED = "CREATE_INTEGRATION_REQUESTED"

export const CREATE_INTEGRATION_SUCCESS = "CREATE_INTEGRATION_SUCCESS"

export const CREATE_INTEGRATION_FAILURE = "CREATE_INTEGRATION_FAILURE"

// ✨ Profile action types removed - migrated to React Query hooks:
// - useSavedProfiles (fetch)
// - useDeleteProfile (delete)  
// - useCreateProfile (create)
// - useEditProfile (update)

export const SET_DEFAULT_AUDIO_PROFILE = "SET_DEFAULT_AUDIO_PROFILE"

export const UPDATE_PRONUNCIATION_LIBRARY = "UPDATE_PRONUNCIATION_LIBRARY"